import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Flame, Ear, Shield, HeartHandshake } from 'lucide-react';
export function GuideSolution() {
  const pillars = [{
    icon: <Flame className="w-8 h-8 text-[#c4607a]" data-id="element-100" />,
    text: 'Detectar el patrón antes de explotar'
  }, {
    icon: <Ear className="w-8 h-8 text-[#c4607a]" data-id="element-101" />,
    text: 'Escuchar sin activarte'
  }, {
    icon: <Shield className="w-8 h-8 text-[#c4607a]" data-id="element-102" />,
    text: 'Bajar la guardia sin dejar de ser vos'
  }, {
    icon: <HeartHandshake className="w-8 h-8 text-[#c4607a]" data-id="element-103" />,
    text: 'Reconstruir conexión con micro-gestos diarios'
  }];
  return <section className="py-24 px-4 relative" data-id="element-104">
      {/* Soft glow background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFF5F7] via-[#FEF0F3] to-[#FFF5F7]" data-id="element-105"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-106">
        <FadeIn data-id="element-107">
          <div className="text-center mb-20" data-id="element-108">
            <h2 className="text-3xl md:text-5xl font-serif text-[#c4607a] mb-6" data-id="element-109">
              La verdad incómoda <br data-id="element-110" />
              <span className="text-[#4a2535] text-2xl md:text-4xl" data-id="element-111">
                (y liberadora)
              </span>
            </h2>
            <p className="text-2xl text-[#7a5568] mb-8" data-id="element-112">
              El amor no se fue. Está tapado.
            </p>
            <p className="text-lg text-[#7a5568] max-w-2xl mx-auto mb-12" data-id="element-113">
              Tapado por defensas. Por cansancio. Por reacciones automáticas.
            </p>

            <div className="inline-block bg-[#c4607a]/5 px-8 py-6 rounded-2xl border border-[#c4607a]/20" data-id="element-114">
              <p className="text-xl md:text-2xl text-[#4a2535] font-serif" data-id="element-115">
                <span className="mr-2" data-id="element-116">👉</span>
                No necesitás que él cambie primero. Necesitás salir del ciclo.
              </p>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20" data-id="element-117">
          <FadeIn direction="right" data-id="element-118">
            <div className="space-y-6" data-id="element-119">
              <h3 className="text-4xl md:text-5xl font-script text-[#c4607a] mb-4" data-id="element-120">
                Lo Estás Haciendo Bien
              </h3>
              <p className="text-lg text-[#7a5568] leading-relaxed" data-id="element-121">
                Es una guía emocional práctica para mujeres que aman, intentan…
                y están cansadas de pelear siempre por lo mismo.
              </p>
              <p className="text-lg text-[#7a5568] leading-relaxed font-semibold" data-id="element-122">
                No es terapia. No es teoría. No es autoayuda vacía.
              </p>
              <p className="text-lg text-[#7a5568] leading-relaxed" data-id="element-123">
                Es una hoja de ruta emocional para:
              </p>
            </div>
          </FadeIn>

          <div className="grid gap-4" data-id="element-124">
            {pillars.map((pillar, i) => <FadeIn key={i} delay={i * 0.1} direction="left" data-id="element-125">
                <div className="bg-white p-6 rounded-xl border border-[#f0d0dc] flex items-center gap-4 hover:border-[#c4607a]/40 transition-colors duration-300 shadow-sm" data-id="element-126">
                  <div className="bg-[#FEF0F3] p-3 rounded-full border border-[#f0d0dc]" data-id="element-127">
                    {pillar.icon}
                  </div>
                  <span className="text-lg text-[#4a2535]" data-id="element-128">{pillar.text}</span>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn data-id="element-129">
          <div className="text-center max-w-3xl mx-auto bg-white p-10 rounded-3xl border border-[#f0d0dc] shadow-[0_12px_40px_rgba(196,96,122,0.08)] relative overflow-hidden" data-id="element-130">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#f4b8c8] rounded-full blur-[100px] opacity-20" data-id="element-131"></div>
            <p className="text-xl md:text-2xl text-[#7a5568] mb-6 relative z-10" data-id="element-132">
              Porque la conexión no vuelve con una charla gigante. Vuelve con
              pequeñas chispas diarias.
            </p>
            <p className="text-3xl md:text-4xl font-serif text-[#c4607a] relative z-10 flex items-center justify-center gap-3" data-id="element-133">
              <Flame className="fill-[#c4607a]" data-id="element-134" />
              Como una fogata.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}